(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["purchase-router"] && !Shopify.designMode) return;
  try {
    (function () {
    var SHOPIFY_COUNTRIES = new Set(['AU', 'CA', 'GB', 'JP', 'NZ', 'US']);
    var AMAZON_MARKETS = {
      MX: 'MX',
      DE: 'DE', AT: 'DE', BG: 'DE', CZ: 'DE', DK: 'DE', EE: 'DE', FI: 'DE', GR: 'DE', HR: 'DE', HU: 'DE', LT: 'DE', LV: 'DE', PL: 'DE', RO: 'DE', SI: 'DE', SK: 'DE',
      FR: 'FR',
      IT: 'IT', MT: 'IT', SM: 'IT', VA: 'IT',
      ES: 'ES', PT: 'ES', AD: 'ES',
      NL: 'NL', BE: 'NL', LU: 'NL',
      SE: 'SE',
      IE: 'IE',
      AE: 'AE',
      SA: 'SA'
    };
    var AMAZON_STORES = {
      MX: 'Amazon.com.mx', DE: 'Amazon.de', FR: 'Amazon.fr', IT: 'Amazon.it', ES: 'Amazon.es',
      NL: 'Amazon.nl', SE: 'Amazon.se', IE: 'Amazon.ie', AE: 'Amazon.ae', SA: 'Amazon.sa'
    };
    var AMAZON_HOSTS = {
      MX: 'amazon.com.mx', DE: 'amazon.de', FR: 'amazon.fr', IT: 'amazon.it', ES: 'amazon.es',
      NL: 'amazon.nl', SE: 'amazon.se', IE: 'amazon.ie', AE: 'amazon.ae', SA: 'amazon.sa'
    };
    var ISO_CODES = 'AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
    var OVERRIDE_KEY = 'clpa_country_override_v1';
    var DETECTED_KEY = 'clpa_country_detected_v1';

    function validCountry(value) {
      return typeof value === 'string' && /^[A-Z]{2}$/.test(value);
    }

    function safeAmazonUrl(market, value) {
      try {
        var parsed = new URL(String(value || ''));
        var hostname = parsed.hostname.toLowerCase().replace(/^www\./, '');
        if (
          parsed.protocol !== 'https:' ||
          parsed.username ||
          parsed.password ||
          parsed.port ||
          !AMAZON_HOSTS[market] ||
          hostname !== AMAZON_HOSTS[market]
        ) {
          return '';
        }
        return parsed.href;
      } catch (error) {
        return '';
      }
    }

    function readStorage(storage, key) {
      try {
        var value = storage.getItem(key);
        return validCountry(value) ? value : '';
      } catch (error) {
        return '';
      }
    }

    function writeStorage(storage, key, value) {
      try {
        storage.setItem(key, value);
      } catch (error) {
        return;
      }
    }

    function removeStorage(storage, key) {
      try {
        storage.removeItem(key);
      } catch (error) {
        return;
      }
    }

    function replaceToken(template, token, value) {
      return String(template || '').split(token).join(value);
    }

    function countryDisplayName(code) {
      try {
        return new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }).of(code) || code;
      } catch (error) {
        return code;
      }
    }

    function readAmazonLinks(root) {
      try {
        var payload = JSON.parse(root.querySelector('[data-clpa-amazon-router-json]').textContent || 'null');
        return payload && payload.links && typeof payload.links === 'object' ? payload.links : {};
      } catch (error) {
        return {};
      }
    }

    async function detectCountry(root) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 3500);
      try {
        var response = await fetch(root.dataset.geolocationUrl, {
          cache: 'no-store',
          credentials: 'same-origin',
          signal: controller.signal
        });
        if (!response.ok) return '';
        var payload = await response.json();
        var country = payload && payload.detected_values && payload.detected_values.country
          ? String(payload.detected_values.country.handle || '').toUpperCase()
          : '';
        return validCountry(country) ? country : '';
      } catch (error) {
        return '';
      } finally {
        window.clearTimeout(timeout);
      }
    }

    function setupCountrySelect(root) {
      var select = root.querySelector('[data-clpa-country-select]');
      if (!select || select.options.length) return;
      var options = ISO_CODES.map(function (code) {
        return { code: code, name: countryDisplayName(code) };
      }).sort(function (left, right) {
        return left.name.localeCompare(right.name);
      });
      options.forEach(function (option) {
        var element = document.createElement('option');
        element.value = option.code;
        element.textContent = option.name + ' (' + option.code + ')';
        select.appendChild(element);
      });
    }

    function initRouter(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      setupCountrySelect(root);

      var row = root.closest('.type_buy_buttons') || root.parentElement;
      var purchase = row ? row.querySelector('[data-clpa-shopify-purchase]') : null;
      var amazonLink = root.querySelector('[data-clpa-amazon-link]');
      var status = root.querySelector('[data-clpa-router-status]');
      var changeButton = root.querySelector('[data-clpa-country-change]');
      var dialog = root.querySelector('[data-clpa-country-dialog]');
      var select = root.querySelector('[data-clpa-country-select]');
      var links = readAmazonLinks(root);
      var route = 'pending';
      var resolutionVersion = 0;

      function blockPurchase(event) {
        if (route !== 'shopify' && purchase && purchase.contains(event.target)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }

      if (row) {
        row.addEventListener('click', blockPurchase, true);
        row.addEventListener('submit', blockPurchase, true);
      }

      function hidePurchase() {
        if (!purchase) return;
        purchase.hidden = true;
        purchase.setAttribute('inert', '');
      }

      function showPurchase() {
        if (!purchase) return;
        purchase.hidden = false;
        purchase.removeAttribute('inert');
      }

      function setStatus(message, state) {
        status.textContent = message;
        status.dataset.route = state;
      }

      function applyRoute(country) {
        var countryName = validCountry(country) ? countryDisplayName(country) : '';
        amazonLink.hidden = true;
        amazonLink.removeAttribute('href');
        changeButton.hidden = false;

        if (root.dataset.purchaseDisabled === 'true') {
          route = 'none';
          hidePurchase();
          setStatus(root.dataset.copyDisabled, route);
          return;
        }

        if (!validCountry(country)) {
          route = 'none';
          hidePurchase();
          setStatus(root.dataset.copyDetectFailed, route);
          if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
          return;
        }

        select.value = country;
        root.dataset.resolvedCountry = country;
        if (SHOPIFY_COUNTRIES.has(country)) {
          route = 'shopify';
          showPurchase();
          setStatus(replaceToken(root.dataset.copyStore, '__COUNTRY__', countryName), route);
          return;
        }

        hidePurchase();
        var market = AMAZON_MARKETS[country];
        var url = market ? safeAmazonUrl(market, links[market]) : '';
        if (market && url) {
          route = 'amazon';
          amazonLink.href = url;
          amazonLink.hidden = false;
          var message = replaceToken(root.dataset.copyAmazon, '__COUNTRY__', countryName);
          message = replaceToken(message, '__STORE__', AMAZON_STORES[market] || market);
          setStatus(message, route);
          return;
        }

        route = 'none';
        setStatus(replaceToken(root.dataset.copyUnavailable, '__COUNTRY__', countryName), route);
      }

      async function resolveCountry(ignoreOverride) {
        var currentResolution = ++resolutionVersion;
        route = 'pending';
        hidePurchase();
        amazonLink.hidden = true;
        changeButton.hidden = true;
        setStatus(root.dataset.copyChecking, route);

        if (!ignoreOverride) {
          var override = readStorage(window.localStorage, OVERRIDE_KEY);
          if (override) {
            applyRoute(override);
            return;
          }
        }

        var selected = String(root.dataset.selectedCountry || '').toUpperCase();
        var primary = String(root.dataset.primaryCountry || '').toUpperCase();
        if (!ignoreOverride && validCountry(selected) && selected !== primary) {
          applyRoute(selected);
          return;
        }

        if (!ignoreOverride) {
          var detected = readStorage(window.sessionStorage, DETECTED_KEY);
          if (detected) {
            applyRoute(detected);
            return;
          }
        }

        var country = await detectCountry(root);
        if (currentResolution !== resolutionVersion) return;
        if (country) writeStorage(window.sessionStorage, DETECTED_KEY, country);
        applyRoute(country);
      }

      changeButton.addEventListener('click', function () {
        if (validCountry(root.dataset.resolvedCountry)) select.value = root.dataset.resolvedCountry;
        if (dialog && typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      });

      root.querySelector('[data-clpa-country-save]').addEventListener('click', function () {
        var country = String(select.value || '').toUpperCase();
        if (!validCountry(country)) return;
        resolutionVersion += 1;
        writeStorage(window.localStorage, OVERRIDE_KEY, country);
        if (dialog && dialog.open) dialog.close();
        applyRoute(country);
      });

      root.querySelector('[data-clpa-country-detect]').addEventListener('click', function () {
        removeStorage(window.localStorage, OVERRIDE_KEY);
        removeStorage(window.sessionStorage, DETECTED_KEY);
        if (dialog && dialog.open) dialog.close();
        resolveCountry(true);
      });

      resolveCountry(false);
    }

    function initializeAll() {
      document.querySelectorAll('[data-clpa-country-router]').forEach(initRouter);
    }

    document.addEventListener('click', function (event) {
      var option = event.target.closest('form[action*="localization"] [data-value]');
      if (!option) return;
      var country = String(option.dataset.value || '').toUpperCase();
      if (validCountry(country)) writeStorage(window.localStorage, OVERRIDE_KEY, country);
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll);
    } else {
      initializeAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
